define(function (require) {
    var $ = require("jquery");
    var util = require("@modules/utils");
    var tracker = require("@modules/interactiontracker/interactionTracker");
    require("jquery-inputmask");

    // Check for qs indicating it was linked to from email
    if ($("#memberFirstTimeLoginButton").length || $("#memberLoginSubmit").length) {
        var interactionValue = getQueryString()["interaction"];
        if (interactionValue) {
            console.log("query = " + interactionValue);
            tracker.RecordGoalFn(interactionValue);
        }
    }

    function getQueryString() {
        var result = {},
            queryString = location.search.slice(1),
            re = /([^&=]+)=([^&]*)/g,
            m;

        while ((m = re.exec(queryString))) {
            result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
        }
        return result;
    }

    function highlightLoginFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error:visible").each(function (index, element) {
            $(element).parent("div.form-item").addClass("is-error");
            $(element).parent(".form-item-group").parent().addClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").addClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
        });
    }

    function undoLoginFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error").each(function (index, element) {
            $(element).parent("div.form-item").removeClass("is-error");
            $(element).parent(".form-item-group").parent().removeClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").removeClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
        });
    }

    function createValidationSummary() {
        $("div.validation-summary-errors").remove();
        var errorMessages = $("span.field-validation-error:visible")
            .map(function () {
                return $.trim($(this).text());
            })
            .get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        var errorMessageCount = $(errorMessages).length;
        var $header = $("header.form-header");
        var listHtml = "";
        $header.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong class='form-error-text'>" + errorMessageCount + $(".hidden.validation-error-count").html() + "</strong>";
        listHtml += "<ul>";
        $(errorMessages).each(function (index, element) {
            listHtml += "<li>" + element + "</li>";
        });
        listHtml += "</ul>";
        $(listHtml).appendTo("#javascriptValidationSummary");
    }

    undoLoginFieldHighlights();
    highlightLoginFields();

    $("#memberLoginSubmit").click(function (e) {
        e.preventDefault();

        undoLoginFieldHighlights();

        $("span.field-validation-error.form-error-hint").hide();

        var username = $("#username").val();
        var password = $("#password").val();
        var passwordPlaceholder = $("#password").data("placeholder-text-for-validation");

        var isValid = true;

        if (!username) {
            isValid = false;
            $("#usernameError").show();
        }

        if (!password || password === passwordPlaceholder) {
            isValid = false;
            $("#passwordError").show();
        }

        if (isValid) {
            undoLoginFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#userLogin, form#oAuthLogin").submit();
        } else {
            highlightLoginFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#memberFirstTimeLoginButton").click(function (e) {
        e.preventDefault();

        undoLoginFieldHighlights();

        var isValid = true;

        $("#span.field-validation-error.form-error-hint").hide();

        var firstName = $("#first-name").val();
        var lastName = $("#last-name").val();
        var monthOfBirth = $("#date-month").val();
        var dayOfBirth = $("#date-day").val();
        var yearOfBirth = $("#date-year").val();
        var memberId = $("#member-id").val();
        var monthDayRegex = /^\d{1,2}$/;
        var yearRegex = /^\d{4}$/;

        if (!firstName) {
            isValid = false;
            $("#firstNameError").show();
        }

        if (!lastName) {
            isValid = false;
            $("#lastNameError").show();
        }

        if (!monthOfBirth || !monthDayRegex.test(monthOfBirth) || !dayOfBirth || !monthDayRegex.test(dayOfBirth) || !yearOfBirth || !yearRegex.test(yearOfBirth)) {
            isValid = false;
            $("#dateOfBirthError").show();
        }

        if (!memberId) {
            isValid = false;
            $("#memberIdError").show();
        }

        if (isValid) {
            undoLoginFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#firstTimeLogin").submit();
        } else {
            highlightLoginFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#memberFirstTimeStep2Button").click(function (e) {
        e.preventDefault();

        undoLoginFieldHighlights();

        var isValid = true;

        $("#span.field-validation-error.form-error-hint").hide();

        var answer = $("#answer").val();

        if (!answer) {
            isValid = false;
            $("#SecretAnswer").show();
        }

        if (isValid) {
            undoLoginFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#firstTimeLogin").submit();
        } else {
            highlightLoginFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#caregiverFirstTimeLoginButton").click(function (e) {
        e.preventDefault();

        undoLoginFieldHighlights();

        var isValid = true;

        $("#span.field-validation-error.form-error-hint").hide();

        var firstName = $("#first-name").val();
        var lastName = $("#last-name").val();
        var monthOfBirth = $("#date-month").val();
        var dayOfBirth = $("#date-day").val();
        var email = $("#email").val();
        var monthDayRegex = /^\d{1,2}$/;

        if (!firstName) {
            isValid = false;
            $("#firstNameError").show();
        }

        if (!lastName) {
            isValid = false;
            $("#lastNameError").show();
        }

        if (!monthOfBirth || !monthDayRegex.test(monthOfBirth) || !dayOfBirth || !monthDayRegex.test(dayOfBirth)) {
            isValid = false;
            $("#dateOfBirthError").show();
        }
        if (!util.isValidEmail(email)) {
            isValid = false;
            $("#emailError").show();
        }
        if (isValid) {
            undoLoginFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#firstTimeLogin").submit();
        } else {
            highlightLoginFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#globalLoginSubmit").click(function (e) {
        e.preventDefault();

        undoLoginFieldHighlights();

        $("span.field-validation-error.form-error-hint").hide();

        var username = $("#gusername").val();
        var password = $("#gpassword").val();
        var passwordPlaceholder = $("#gpassword").data("placeholder-text-for-validation");

        var isValid = true;

        if (!username) {
            isValid = false;
            $("#gusernameError").show();
        }

        if (!password || password === passwordPlaceholder) {
            isValid = false;
            $("#gpasswordError").show();
        }

        if (isValid) {
            undoLoginFieldHighlights();
            $("javascriptValidationSummary").remove();
            $("form#globalLoginForm").submit();
        } else {
            highlightLoginFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#mfa-option-email").click(function () {
        $("#MFAType").val("Email");
        $("#sendMfaCode").removeAttr("disabled");
    });

    $("#mfa-option-sms").click(function () {
        $("#MFAType").val($("#TextAuthType").val());
        $("#sendMfaCode").removeAttr("disabled");
    });

    $("#mfa-option-voice").click(function () {
        $("#MFAType").val($("#VoiceAuthType").val());
        $("#sendMfaCode").removeAttr("disabled");
    });

    var isMfaCodeBeingSent = false;
    $("#sendMfaCode").on("click", function (ev) {
        if (isMfaCodeBeingSent) {
            return false;
        } else {
            isMfaCodeBeingSent = true;
        }
    });

    var isMfaCodeBeingVerified = false;
    $("#verifyMfaCode").click(function (e) {
        if (isMfaCodeBeingVerified) {
            return false;
        } else {
            isMfaCodeBeingVerified = true;
        }
    });

    /*
    //interop form input masking
    $(".interop #dob").inputmask("mm/dd/yyyy", { placeholder: "MM/DD/YYYY" });

    $(".interop form .submit-container>button").click(function (e) {
        e.preventDefault();
        $(".field-validation-error.form-error-hint").hide();

        var fields = [];
        var formFields = $(".interop form").serializeArray();
        formFields.forEach(function (field) {
            if (field.name === "new-password") {
                fields.push({
                    name: "#" + field.name,
                    valid: util.isValidPassword($("#" + field.name).val())
                });
            } else if (field.name === "confirm-password") {
                fields.push({
                    name: "#" + field.name,
                    valid: $("#new-password").val() === $("#confirm-password").val()
                });
            } else if (field.name === "dob") {
                fields.push({
                    name: "#" + field.name,
                    valid: $("#dob").inputmask("isComplete")
                });
            } else {
                fields.push({
                    name: "#" + field.name,
                    valid: field.value.length > 0
                });
            }
        });

        fields.forEach(function (field) {
            if (field.valid) {
                $(field.name).next(".form-error-hint").hide();
            } else {
                $(field.name).next(".form-error-hint").show();
            }
        });

        if (
            fields.filter(function (field) {
                return !!field.valid;
            }).length === fields.length
        ) {
            $(e.target).closest("form").submit();
        } else {
            var $firstInvalid = $(
                fields.find(function (field) {
                    return field.valid === false;
                }).name
            );

            if ($firstInvalid.length) {
                $("html,body").animate(
                    {
                        scrollTop: $firstInvalid.offset()["top"]
                    },
                    "slow",
                    function () {
                        $firstInvalid.focus();
                    }
                );
            }
        }
    });
    */

});
